import { oldApiVisiretail } from 'libs/axios'

export const getStatistics = ({ since, until }) => oldApiVisiretail.get(`/v1/reports?since=${since}&until=${until}`)

export const getDailyClickStatistics = ({ since, until }) =>
  oldApiVisiretail.get(`/v1/daily-reports?since=${since}&until=${until}`)
